import React, { useEffect } from 'react'
import { useLocation } from "react-router";

const host = [
    `www.pping.${process.env.REACT_APP_TLD}`,
    `pc.pping.${process.env.REACT_APP_TLD}`,
    `shopping.pping.${process.env.REACT_APP_TLD}`,
    `stdpc.pping.${process.env.REACT_APP_TLD}`,
]

const attachQueryString = () => {
    const {search} = useLocation()

    if(search.includes('ad_code')){
        const queryStringAdCode = new URLSearchParams(search).get('ad_code')
        if(queryStringAdCode === 'dap001' ||
            queryStringAdCode === 'dap004' ||
            queryStringAdCode === 'dap007' ||
            queryStringAdCode === 'dap012' ||
            queryStringAdCode === 'dap017'){
            return search
        }
    }
    return ''
}

const TopBanner = ({ onBannerClose, mainTopBannerVisible }) => {
    const baseURL = `${process.env.REACT_APP_AD_URL}/`
    const hostName = window.location.hostname

    useEffect(() => {
        if (host.indexOf(hostName) < 0){
            onBannerClose()
        }
    }, [])

    let mainTop = null
    if (hostName === host[0]) {
        mainTop = `${baseURL}dap001` + attachQueryString()
    } else if (hostName === host[1]) {
        mainTop = `${baseURL}dap004` + attachQueryString()
    } else if (hostName === host[2]) {
        if (window.location.pathname.split('/')[1] === 'detail') {
            mainTop = `${baseURL}dap007` + attachQueryString()
        } else {
            mainTop = `${baseURL}dap012` + attachQueryString()
        }
    } else if (hostName === host[3]) {
        mainTop = `${baseURL}dap017` + attachQueryString()
    }

    return (
        <>
            {(mainTopBannerVisible && mainTop) && (
                <div className="HAdLine">
                    <div className="HAStage">
                        <iframe src={mainTop} className="adv-itembox_conts_frame" title="행복쇼핑" scrolling="no" style={{width: "100%", height: "100%", border: "none"}}></iframe>
                    </div>
                    <button type="button" className="closeBtn" onClick={()=> onBannerClose()}><span className="ir">닫기</span></button>
                </div>
            )}
        </>
    )
}

export default TopBanner



// WEBPACK FOOTER //
// ./src/header/component/topBanner.js